module.exports = __webpack_public_path__ + "img/avatar.b2311df7.jpeg";